// Design System
import Input from 'jl-design-system/elements/input/Input';

// Checkout Forms
import getRegExp, { lettersNumbersDotDashApostropheSpacePattern } from 'checkout-forms/form/regex';

// Config
import { restrictInputLettersNumbersDotDashApostropheSpaces } from '../normalizers/excludeSymbols';

const CLICK_AND_COLLECT_SEARCH = {
  component: Input,
  type: 'text',
  name: 'collectionPointSearchTerm',
  id: 'collectionPointSearchTerm',
  className: 'fieldLarge',
  label: 'Enter a postcode, town or shop name',
  required: true,
  maxLength: 150,
  validationMessageKeys: {
    required: 'Please enter a shop name or location',
    regex: 'Please remove the invalid characters to continue',
  },
  regex: getRegExp(lettersNumbersDotDashApostropheSpacePattern),
  normalize: restrictInputLettersNumbersDotDashApostropheSpaces,
};

export default CLICK_AND_COLLECT_SEARCH;
